import Vue from 'vue';
import VueI18n from 'vue-i18n';

import locale from '@/utils/init-locale';
import ru from '@/locale/ru.json';
import en from '@/locale/en.json';

/* eslint-disable camelcase */
import ru_aurus from '@/locale/aurus/ru.json';
import en_aurus from '@/locale/aurus/en.json';
import ru_sollers from '@/locale/sollers/ru.json';
import en_sollers from '@/locale/sollers/en.json';
import ru_argo from '@/locale/argo/ru.json';
import en_argo from '@/locale/argo/en.json';
/* eslint-enable camelcase */

import config from '@/utils/config';

const dependentMessages = {
  ru_aurus, en_aurus, ru_sollers, en_sollers, ru_argo, en_argo,
};

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale,
  fallbackLocale: 'en',
  messages: { ru, en },
  silentFallbackWarn: true,
});

i18n.mergeLocaleMessage('ru', dependentMessages[`ru_${config.styleName}`]);
i18n.mergeLocaleMessage('en', dependentMessages[`en_${config.styleName}`]);

export default i18n;
